import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';

export type TenderIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const TenderIllustration = ({ ...props }: TenderIllustrationProps) => (
  <BaseIllustration width="64" height="64" viewBox="0 0 64 64" {...props}>
    <path
      d="M26.7 56H4C2.89543 56 2 55.1046 2 54V4C2 2.89543 2.89543 2 4 2H38C39.1046 2 40 2.89543 40 4V27.0714"
      fill="none"
      strokeWidth="2"
    />
    <rect x="8" y="8" width="26" height="10" rx="1" fill="none" strokeWidth="2" />
    <rect x="8" y="24" width="6" height="6" rx="1" fill="none" strokeWidth="2" />
    <rect x="8" y="34" width="6" height="6" rx="1" fill="none" strokeWidth="2" />
    <rect x="8" y="44" width="6" height="6" rx="1" fill="none" strokeWidth="2" />
    <rect x="18" y="24" width="6" height="6" rx="1" fill="none" strokeWidth="2" />
    <rect x="18" y="34" width="6" height="6" rx="1" fill="none" strokeWidth="2" />
    <rect x="18" y="44" width="6" height="6" rx="1" fill="none" strokeWidth="2" />
    <rect x="28" y="24" width="6" height="6" rx="1" fill="none" strokeWidth="2" />
    <path d="M31 34H30C28.8954 34 28 34.8954 28 36V41" fill="none" strokeWidth="2" />
    <circle cx="47" cy="47" r="15" fill="none" strokeWidth="2" />
    <path d="M46 47C43.7909 47 42 45.433 42 43.5C42 41.567 43.7909 40 46 40" fill="none" strokeWidth="2" />
    <path d="M48 54C50.2091 54 52 52.433 52 50.5C52 48.567 50.2091 47 48 47" fill="none" strokeWidth="2" />
    <line x1="46" y1="40" x2="52" y2="40" fill="none" strokeWidth="2" />
    <line x1="42" y1="54" x2="48" y2="54" fill="none" strokeWidth="2" />
    <line x1="46" y1="47" x2="48" y2="47" fill="none" strokeWidth="2" />
    <line x1="47" y1="35" x2="47" y2="39" fill="none" strokeWidth="2" />
    <line x1="47" y1="55" x2="47" y2="59" fill="none" strokeWidth="2" />
  </BaseIllustration>
);

TenderIllustration.displayName = 'TenderIllustration';
